import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { TableService } from '../../services/table.service';
import { ChangeDetectorRef } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { firstValueFrom } from 'rxjs';
import { FilterPayload } from '../../services/table.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { HostListener } from '@angular/core';
import { ErrorHandler } from '../../utils/error-handler';
import { exportRowsToExcel } from '../../utils/excel-export';

@Component({
  selector: 'app-fecapacities',
  templateUrl: './fecapacities.component.html',
  styleUrls: ['./fecapacities.component.scss'],
  standalone: false,
})
export class FecapacitiesComponent implements OnInit {
  spinnerBoolean: boolean =  true;
  userEmail: string = '';
  data: any[] = [];
  lookupData: { [key: string]: string[] } = {};
  selectedRows: any[] = [];
  copiedRows: any[] = [];
  newRow: any = null;
  hoveredRowIndex: number | null = null;
  devAreaAdminOptions: string[] = [];
  facilityTypeAdminOptions: string[] = [];
  ipsomaxLoaded: boolean = false;
  rowScopedLookup: { [rowId: string]: { [key: string]: string[] } } = {};
  allDevAreas: string[] = [];
  allFacilityTypes: string[] = [];
  allFacilityNames: string[] = [];  lastRowNumber: number = 0;
  hasMore: boolean = true;
  loading: boolean = false;
  @ViewChild(CdkVirtualScrollViewport) viewport!: CdkVirtualScrollViewport;
  @ViewChild('deleteConfirmDialog') deleteConfirmDialog!: TemplateRef<any>;
  @ViewChild('exportOptionsDialog') exportOptionsDialog!: TemplateRef<any>;
  public dialogMessage: string = '';
  private requestInFlight: boolean = false;
  private lastRequestedRow: number | null = null;
  backendFilters: any = {
    developmentArea: null,
    facilityName: null,
    facilityType: null,
    train: null,
    startDate: null,
    endDate: null,
  };

  activeFilter: string = '';
  showFloatingFilter: boolean = false;
  dropdownPosition = { top: 0, left: 0 };
  filterSearch: { [key: string]: string } = {};
  multiFilters: { [key: string]: string[] } = {};
  dynamicFilterOptions: { [key: string]: string[] } = {};
  isLoadingFilterOptions: boolean = false;
  rfsFilter = { start: '', end: '' };
  showAddFacilityModal: boolean = false;
  newFacility: any = {
    developmentArea: '',
    facilityType: '',
    facilityName: '',
    targetRow: null as any,
  };
  
  columns = [
    {field: 'developmentArea',header: 'Development Area',editable: true,lookup: true,required: true,},
    {field: 'facilityType',header: 'Facility Type',editable: true,lookup: true,required: true,},
    {field: 'facilityName',header: 'Facility Name',editable: true,lookup: true,required: true},
    {field: 'train',header: 'Train',editable:false,lookup: true,required: true,},
    {field: 'rfsd', header: 'RFSD', editable: true, required: true },
    // {field: 'ipsomax', header: 'IPSOMAX', editable: true, lookup: true },
    {field: 'selectedOilCapacity',header: 'Selected Oil Capacity (BPD)',editable: true,required: true},
    {field: 'selectedWaterCapacity',header: 'Selected Water Capacity (BPD)',editable: true,required: true},
    {field: 'selectedGasCapacity',header: 'Selected Gas Capacity (MSCFD)',editable: true,required: true},
    {field: 'plannedOilCapacity',header: 'Planned Oil Capacity (BPD)',editable: true,required: true},
    {field: 'plannedWaterCapacity',header: 'Planned Water Capacity (BPD)',editable: true,required: true},
    {field:'plannedGasCapacity',header: 'Planned Gas Capacity (MSCFD)',editable: true,required: true},
    // {field: 'calculatedOilCapacity',header: 'Calculated Oil Capacity (BPD)',editable: false},
    // { field: 'calculatedWaterCapacity',header: 'Calculated Water Capacity (BPD)',editable: false},
    // {field: 'calculatedGasCapacity',header: 'Calculated Gas Capacity (MSCFD)',editable: false},
    {field: 'permittedOilRate',header: 'Permitted Oil Rate (BPD)',editable: true},
    {field: 'permittedGasRate',header: 'Permitted Gas Rate (MSCFD)',editable: true},
    {field: 'permittedWaterRate',header: 'Permitted Water Rate (BPD)',editable: true},

    { field: 'comments', header: 'Comments', editable: true },
  ];

  constructor(
    private tableService: TableService,
    private msalService: MsalService,
    private toastr: ToastrService,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef

  ) {}

public async ngOnInit() {
    const account = this.msalService.instance.getActiveAccount();
    if (account?.username) {
      this.userEmail = account.username;
      await this.loadTableData();
      await this.loadLookupData();
      await this.loadAdminDropdowns();
    } else {
      this.toastr.info('User is not authenticated.');
    }
    this.spinnerBoolean = false
}
// Handle save action for new or modified rows
public  async handleSave(): Promise<void> {
  const requiredFields = this.columns
    .filter((col) => col.required)
    .map((col) => col.field);
  const invalidRows = this.data.filter((row) => {
    if (!row.isNew && !row._rowEdited) return false;
    return requiredFields.some((field) => {
      const value = row[field];
      return value === undefined || value === null || value === '';
    });
  });
  if (invalidRows.length) {
    this.toastr.info('Please fill all required fields before saving.');
    return;
  }
  const changedRows = this.data.filter((row) => row.isNew || row._rowEdited);
  changedRows.forEach((row) => (row.userEmail = this.userEmail));
  if (!changedRows.length) {
    this.toastr.info('No new or modified rows to save.');
    return;
  }
  try {
    // normalize numeric fields so service receives consistent types
    const normalizeNumber = (v: any) => {
      if (v === null || v === undefined || v === '') return 0;
      const n = Number(v);
      return isNaN(n) ? 0 : n;
    };

    const payloadRows = changedRows.map((row: any) => ({
      ...row,
      selectedOilCapacity: normalizeNumber(row.selectedOilCapacity),
      selectedWaterCapacity: normalizeNumber(row.selectedWaterCapacity),
      selectedGasCapacity: normalizeNumber(row.selectedGasCapacity),
      plannedOilCapacity: normalizeNumber(row.plannedOilCapacity),
      plannedWaterCapacity: normalizeNumber(row.plannedWaterCapacity),
      plannedGasCapacity: normalizeNumber(row.plannedGasCapacity),
      permittedOilRate: normalizeNumber(row.permittedOilRate),
      permittedWaterRate: normalizeNumber(row.permittedWaterRate),
      permittedGasRate: normalizeNumber(row.permittedGasRate),
      rfsd: row.rfsd || null,
    }));

    const results = await this.tableService.saveFeCapacitiesData(payloadRows);
    const parsedResults = results.map((r) => ErrorHandler.parseApiResult(r));
    const failed = parsedResults.filter((r) => !r.success);
    const selectedResults = failed.length ? failed : parsedResults;
    const messages = Array.from(new Set(selectedResults.map((r) => r.message).filter(Boolean))).join('\n');
    ErrorHandler.showStatusMessageToastr(
      { statusCode: failed.length ? 400 : 200, statusMessage: messages },
      this.toastr
    );
    if (!failed.length) {
      changedRows.forEach((row) => {
        row.isNew = false;
        row._rowEdited = false;
        row.original = { ...row };
      });
      this.newRow = null;
      this.copiedRows = this.copiedRows.filter((r) => !changedRows.includes(r));
      await this.loadTableData();
    }
  } catch (err: any) {
    ErrorHandler.showStatusMessageToastr(err?.error || err, this.toastr);
  }
}

// Return whether a header filter is currently active (used to toggle icon state)
public isFilterActive(field: string): boolean {
    if (!field) return false;
    // RFSD / date range
    if (field === 'rfsd') {
      return Boolean((this.rfsFilter && (this.rfsFilter.start || this.rfsFilter.end)) || this.backendFilters.startDate || this.backendFilters.endDate);
    }

    // Check multi-selects and backend-applied filters
    const multi = this.multiFilters[field];
    if (Array.isArray(multi) && multi.length > 0) return true;

    // If backendFilters has a non-null value for this field, treat it as active
    if (this.backendFilters && this.backendFilters[field]) return true;

    return false;
  }
// Handle delete action for selected rows
public async handleDelete(): Promise<void> {
  if (!this.selectedRows.length) return;
  this.dialogMessage = `Are you sure you want to delete ${this.selectedRows.length} row(s)? This action cannot be undone.`;
  const dialogRef = this.dialog.open(this.deleteConfirmDialog, {
    width: '400px',
    disableClose: true,
  });

  const confirmed = await dialogRef.afterClosed().toPromise();
  if (!confirmed) return;

  try {
    const deletions = this.selectedRows.map(row => {
      return this.tableService.deleteFeCapacity({
        ...row,
        userEmail: this.userEmail
      });
    });
    const results = await Promise.all(deletions);

    const parsedResults = results.map((r) => ErrorHandler.parseApiResult(r));
    const failed = parsedResults.filter((r) => !r.success);
    const selectedResults = failed.length ? failed : parsedResults;
    const messages = Array.from(new Set(selectedResults.map((r) => r.message).filter(Boolean))).join('\n');
    ErrorHandler.showStatusMessageToastr(
      { statusCode: failed.length ? 400 : 200, statusMessage: messages },
      this.toastr
    );

    this.selectedRows = [];
    await this.loadTableData();
  } catch (err: any) {
    ErrorHandler.showStatusMessageToastr(err?.error || err, this.toastr);
  }
}
// Add a new row to the table
public addRow(): void {
    const newRow = {
      ...this.columns.reduce((acc: any, col) => ({ ...acc, [col.field]: '' }), {}),
      isNew: true,
      _rowId: `row_${Date.now()}`,
      _firstSelectedField: null,
      userEmail: this.userEmail
    };
    this.initRowScopedLookup(newRow);
    this.data.unshift(newRow);
    this.copiedRows.push(newRow);
    this.newRow = newRow;
}
// Copy an existing row and add it as a new row
public copyRow(index: number): void {
    const originalRow = this.filteredData[index];
    const copiedRow = this.columns.reduce((acc: any, col) => {
      acc[col.field] = col.field === 'rfsd' ? '' : originalRow[col.field];
      return acc;
    }, {});
    copiedRow.isNew = true;
    copiedRow._rowId = `row_${Date.now()}`;
    copiedRow._firstSelectedField = null,
    copiedRow.userEmail = this.userEmail;
    this.rowScopedLookup[copiedRow._rowId] = {
      developmentArea: this.ensureValuePresent(this.lookupData['developmentArea'], copiedRow.developmentArea),
      facilityType: this.ensureValuePresent(this.lookupData['facilityType'], copiedRow.facilityType),
      facilityName: this.ensureValuePresent(this.lookupData['facilityName'], copiedRow.facilityName),
    };
    this.data.unshift(copiedRow);
    this.copiedRows.push(copiedRow);
    this.newRow = copiedRow;
}
// Toggle selection of a row
public toggleRowSelection(row: any, event: Event): void {
    const isChecked = (event.target as HTMLInputElement).checked;
    this.selectedRows = isChecked
      ? [...this.selectedRows, row]
      : this.selectedRows.filter((r) => r !== row);
}
//To make sure if dropdown values are present in the extracted while copying a row
private ensureValuePresent(options: string[] = [], value: string): string[] {
    if (!value) return options;
    return options.includes(value) ? options : [value, ...options];
}
//Used for fetching lookup options for individual rows while adding anew row
private async initRowScopedLookup(row: any): Promise<void> {
    const id = row._rowId;
    this.rowScopedLookup[id] = {
      developmentArea: [],
      facilityType: [],
      facilityName: [],
    };
    try {
      const filtered = await this.tableService.getFilteredLookupData({
        devArea: null,
        facilityType: null,
        facilityName: null,
      });
      this.rowScopedLookup[id] = {
        developmentArea: filtered.developmentArea || [],
        facilityType: filtered.facilityType || [],
        facilityName: filtered.facilityName || [],
      };
    } catch (err) {
    }
}
// Get lookup options for a specific row and field
public getLookupOptions(rowId: string, field: string): string[] {
    return this.rowScopedLookup[rowId]?.[field] || [];
}
// Handle edit action for a row by updating ipsomax and train values while adding a new row
public async handleEdit(row: any): Promise<void> {
    if (!row.isNew) return;
    const { train, ipsomax } = row;
    try {
      // // const res = await this.tableService.getIpsomaxDetails(ipsomax, train);
      // const result = res?.[0];
      // row.calculatedOilCapacity = result?.calculatedOilCapacity ?? 0;
      // row.calculatedWaterCapacity = result?.calculatedWaterCapacity ?? 0;
      // row.calculatedGasCapacity = result?.calculatedGasCapacity ?? 0;
    } catch (err) {
      this.toastr.error('Failed to load IPSOMAX details.');
    }
}
// Try to populate calculated fields based on ipsomax and train values when the rows are edited
// public async tryPopulateCalculatedFields(row: any): Promise<void> {
//   const ipsomaxName = row.ipsomax;
//   const trainName = row.train;
//   if (!ipsomaxName || !trainName) {
//     return;
//   }
//   try {
//     const res = await this.tableService.getIpsomaxDetails(ipsomaxName, trainName);
//     if (res && res.length > 0) {
//       const result = res[0];
//       row.calculatedOilCapacity = result.calculatedOilCapacity ?? 0;
//       row.calculatedWaterCapacity = result.calculatedWaterCapacity ?? 0;
//       row.calculatedGasCapacity = result.calculatedGasCapacity ?? 0;
//     } else {
//       row.calculatedOilCapacity = 0;
//       row.calculatedWaterCapacity = 0;
//       row.calculatedGasCapacity = 0;
//     }
//   } catch (err) {
//     row.calculatedOilCapacity = 0;
//     row.calculatedWaterCapacity = 0;
//     row.calculatedGasCapacity = 0;
//   }
// }
// Handle facility name change, including adding a new facility
public handleFacilityNameChange(row: any): void {
  const selectedFacility = row.facilityName;
  if (selectedFacility === '__add_new__') {
    if (this.showAddFacilityModal) return; 
    this.newFacility = {
      developmentArea: row.developmentArea || '',
      facilityType: row.facilityType || '',
      facilityName: '',
      targetRow: row,
    };
    setTimeout(() => {
      row.facilityName = ''; 
    }, 0);
    this.showAddFacilityModal = true;
  } else {
    this.onFieldChange(row); 
    this.handleEdit(row);
  }
}
// Save a new facility name entered in the modal
public async saveNewFacility(): Promise<void> {
  const { developmentArea, facilityType, facilityName, targetRow } = this.newFacility;
  const userName = this.userEmail;
  if (!facilityName || !developmentArea || !facilityType) {
    this.toastr.info('Please fill all fields');
    return;
  }
  const payload = {
    existingFacilityName: null,
    newFacilityName: facilityName,
    facilityTypeName: facilityType,
    developmentArea,
    userName
  };
  try {
    const res = await firstValueFrom(this.tableService.insertOrUpdateFacilityName(payload));
    const parsed = ErrorHandler.showStatusMessageToastr(res, this.toastr);

    if (parsed.success) {
      targetRow.facilityName = facilityName;
      targetRow.developmentArea = developmentArea;
      targetRow.facilityType = facilityType;
      targetRow._rowEdited = true;
      const filterPayload: FilterPayload = {
        devArea: developmentArea,
        facilityType: facilityType,
        facilityName: null
      };
      const filtered = await this.tableService.getFilteredLookupData(filterPayload);
      this.rowScopedLookup[targetRow._rowId] = {
        developmentArea: [developmentArea],
        facilityType: this.allFacilityTypes,
        facilityName: filtered.facilityName || []
      };
      const facList = this.rowScopedLookup[targetRow._rowId]['facilityName'];
      if (!facList.includes(facilityName)) {
        facList.push(facilityName);
      }
      if (!this.lookupData['facilityName'].includes(facilityName)) {
        this.lookupData['facilityName'].push(facilityName);
      }
      if (!this.lookupData['developmentArea'].includes(developmentArea)) {
        this.lookupData['developmentArea'].push(developmentArea);
      }
    }
  } catch (err: any) {
    ErrorHandler.showStatusMessageToastr(err?.error || err, this.toastr);
  } finally {
    this.showAddFacilityModal = false;
    this.newFacility = {
      developmentArea: '',
      facilityType: '',
      facilityName: '',
      targetRow: null,
    };
  }
}
// Cancel adding a new facility, reset the target row and reload lookup data
public cancelAddFacility(): void {
  this.showAddFacilityModal = false;
  const targetRow = this.newFacility.targetRow;
  if (targetRow && targetRow._rowId) {
    targetRow.facilityName = null; 
    const devArea = targetRow.developmentArea || null;
    const facilityType = targetRow.facilityType || null;
    const payload: FilterPayload = {
      devArea,
      facilityType,
      facilityName: null
    };
    this.tableService.getFilteredLookupData(payload).then(filtered => {
      this.rowScopedLookup[targetRow._rowId] = {
        developmentArea: devArea ? this.allDevAreas : filtered.developmentArea || [],
        facilityType: this.allFacilityTypes,
        facilityName: filtered.facilityName || [],
      };
    }).catch(err => {
    });
  }
}
// Cancel the current row being added or copied
public cancelRow(): void {
    this.data = this.data.filter((row) => !this.copiedRows.includes(row));
    this.copiedRows.forEach((row) => delete this.rowScopedLookup[row._rowId]);
    this.copiedRows = [];
    this.selectedRows = [];
    this.newRow = null;
} 
public async onFieldChange(row: any): Promise<void> {
  if (!row.isNew) return;
  const id = row._rowId;
  const devArea = row.developmentArea || null;
  const facilityType = row.facilityType || null;
  const payload: FilterPayload = {
    devArea,
    facilityType,
    facilityName: null, 
  };
  try {
    const filtered = await this.tableService.getFilteredLookupData(payload);
    this.rowScopedLookup[id] = {
      developmentArea: devArea ? this.allDevAreas : filtered.developmentArea || [],
      facilityType: this.allFacilityTypes,
      facilityName: filtered.facilityName || [], 
    };
  } catch (err) {
  }
} 
// Load table data (paginated). Pass `lastRowNumber` to load next pages.
private async loadTableData(lastRowNumber: number = 0): Promise<void> {
  try {
    this.loading = true;
    const payload = {
      developmentArea: this.backendFilters.developmentArea,
      facilityName: this.backendFilters.facilityName,
      facilityType: this.backendFilters.facilityType,
      train: this.backendFilters.train,
      startDate: this.backendFilters.startDate,
      endDate: this.backendFilters.endDate,
      lastRowNumber: lastRowNumber,
      userEmail: this.userEmail,
    };

    const res = await this.tableService.getFeCapacitiesData(payload as any);
    const rows = res?.fetable || [];
    const next = (res && (res as any).nextRowNumber !== undefined) ? (res as any).nextRowNumber : null;
    const statusCode = res?.statusCode ?? 200;

    const mappedRows = rows.map((row: any) => {
      if (row.rfsd && row.rfsd.includes('/')) {
        const [month, day, year] = row.rfsd.split('/');
        row.rfsd = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
      }
      row.original = { ...row };
      row.isNew = false;
      return row;
    });

    if (lastRowNumber === 0) {
      this.data = mappedRows;
    } else {
      if (!mappedRows.length && lastRowNumber !== 0) {
        this.hasMore = false;
      } else {
        this.mergeRows(mappedRows);
      }
    }

    // if server returns error or indicates no more rows (nextRowNumber 0/null), stop
    const numericNext = typeof next === 'number' ? (next as number) : null;
    if (statusCode !== 200) {
      this.hasMore = false;
    } else if (numericNext === null || numericNext === 0) {
      this.hasMore = false;
    } else {
      this.hasMore = true;
    }

    // update lastRowNumber only when server provided a positive numeric next pointer
    if (numericNext && numericNext > 0) {
      this.lastRowNumber = numericNext;
    }
    } catch (err) {
    this.hasMore = false;
  } finally {
    this.loading = false;
    this.spinnerBoolean = false;
      this.requestInFlight = false;
      this.lastRequestedRow = null;
    // if the viewport is still at the end after appending rows, trigger next load
    this.checkAndLoadMore();
      // ensure viewport and change detection refresh so new rows render
      try {
        this.cdr.detectChanges();
        if (this.viewport && this.viewport.checkViewportSize) {
          this.viewport.checkViewportSize();
        }
      } catch (e) {
        // safe no-op
      }
  }
}

private mergeRows(newRows: any[]): void {
  const keyOf = (r: any) => `${r.developmentArea}||${r.facilityType}||${r.facilityName}||${r.train}`;
  const existingKeys = new Set(this.data.map(keyOf));
  const toAdd = newRows.filter((r) => !existingKeys.has(keyOf(r)));
  this.data = [...this.data, ...toAdd];
    // ensure virtual scroll updates
    try {
      this.cdr.detectChanges();
      if (this.viewport && this.viewport.checkViewportSize) this.viewport.checkViewportSize();
    } catch (e) {}
}

loadFirstPage(): void {
  this.data = [];
  this.lastRowNumber = 0;
  this.hasMore = true;
  this.loadTableData(0);
}

onScrolledIndexChange(index: number): void {
  const threshold = 20;
  if (this.loading || !this.hasMore || index < this.filteredData.length - threshold) return;

  if (this.requestInFlight) return;
  if (this.lastRequestedRow !== null && this.lastRequestedRow === this.lastRowNumber) return;

  this.requestInFlight = true;
  this.lastRequestedRow = this.lastRowNumber;

  this.loadTableData(this.lastRowNumber)
    .catch(() => {
      this.hasMore = false;
    })
    .finally(() => {
      this.requestInFlight = false;
      this.lastRequestedRow = null;
      this.loading = false;
    });
}

private checkAndLoadMore(): void {
  const threshold = 20;
  if (!this.viewport || this.loading || !this.hasMore) return;
  const range = this.viewport.getRenderedRange();
  const end = range.end;
  if (end >= this.filteredData.length - threshold) {
    // schedule next load to allow the view to settle
    setTimeout(() => {
      if (this.loading || !this.hasMore) return;
      if (this.requestInFlight) return;
      if (this.lastRequestedRow !== null && this.lastRequestedRow === this.lastRowNumber) return;

      this.requestInFlight = true;
      this.lastRequestedRow = this.lastRowNumber;

      this.loadTableData(this.lastRowNumber)
        .catch(() => (this.hasMore = false))
        .finally(() => {
          this.requestInFlight = false;
          this.lastRequestedRow = null;
          this.loading = false;
        });
    }, 50);
  }
}
// Load admin dropdowns for development area and facility type
private  async loadAdminDropdowns(): Promise<void> {
    try {
      const devAreaAdminDetails = await this.tableService.getDevAreaAdminDetails();
      this.devAreaAdminOptions = devAreaAdminDetails.map((r) => r.developmentArea);
      const facilityTypeAdminDetails = await this.tableService.getFacilityTypeAdminDetails();
      this.facilityTypeAdminOptions = facilityTypeAdminDetails.map((r) => r.type);
    } catch (err) {
      this.toastr.error('Failed to load admin dropdowns.');
    }
}
// Load lookup data for dropdowns and filters
private async loadLookupData(): Promise<void> {
    try {
      const res = await this.tableService.getFeLookupValuesAll();
      this.lookupData = res || {};
      this.allDevAreas = [...this.lookupData['developmentArea']];
      this.allFacilityTypes = [...this.lookupData['facilityType']];
      this.allFacilityNames = [...this.lookupData['facilityName']];
      if (res?.train && Array.isArray(res.train)) {
        this.lookupData['train'] = res.train;
      }
    } catch (err) {
      this.toastr.error('Failed to load lookup values.');
    }
}
// Export filtered or full data to XLSX
public async exportToCSV(): Promise<void> {
    const exportData = this.filteredData.length ? this.filteredData : this.data;
    if (!exportData.length) {
      this.toastr.info('No data available to export.');
      return;
    }
    const worksheetData = exportData.map((row: any) => {
      const exportRow: Record<string, any> = {};

      this.columns.forEach((col) => {
        const value = row[col.field];
        exportRow[col.header] = Array.isArray(value) ? value.join(', ') : value ?? '';
      });

      return exportRow;
    });

    await exportRowsToExcel(
      worksheetData,
      this.columns.map((col) => col.header),
      'FeCapacitiesData.xlsx',
      'FECapacities'
    );
}

public openExportDialog(): void {
  this.dialog.open(this.exportOptionsDialog, {
    width: '380px',
    disableClose: true,
  });
}

public async downloadAllData(): Promise<void> {
  try {
    const { blob, fileName } = await this.tableService.exportAllFeCapacitiesData();
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    link.click();
    URL.revokeObjectURL(url);
    this.toastr.success('Export downloaded successfully.');
  } catch (error: any) {
    this.toastr.error(error?.message || 'Failed to download export.');
  }
}
// Unified filter management function - handles opening filter and loading options
async openFloatingFilter(event: MouseEvent, field: string): Promise<void> {
    const target = event.target as HTMLElement;
    const rect = target.getBoundingClientRect();
    this.dropdownPosition = {
      top: rect.bottom - 110 + window.scrollY,
      left: rect.left - 105 + window.scrollX,
    };
    this.activeFilter = field;
    this.showFloatingFilter = true;
    await this.loadFilterOptions();
  }

// Apply selected filter options by sending them to backend and reloading from server
public async applyFilter(field: string): Promise<void> {
  // build backend filter values from selected multiFilters and rfsFilter
  const build = (f: string) => (this.multiFilters[f] && this.multiFilters[f].length ? this.multiFilters[f].join(',') : null);
  this.backendFilters.developmentArea = build('developmentArea');
  this.backendFilters.facilityName = build('facilityName');
  this.backendFilters.facilityType = build('facilityType');
  this.backendFilters.train = build('train');
  this.backendFilters.startDate = this.rfsFilter.start || null;
  this.backendFilters.endDate = this.rfsFilter.end || null;

  this.showFloatingFilter = false;
  this.activeFilter = '';
  this.loadFirstPage();
}

// Clear a specific filter and reload from server
public clearFilter(field: string): void {
  if (field === 'rfsd') {
    this.rfsFilter = { start: '', end: '' };
    this.backendFilters.startDate = null;
    this.backendFilters.endDate = null;
  } else {
    this.multiFilters[field] = [];
    this.filterSearch[field] = '';
    // clear corresponding backend filter
    if (field === 'developmentArea') this.backendFilters.developmentArea = null;
    if (field === 'facilityName') this.backendFilters.facilityName = null;
    if (field === 'facilityType') this.backendFilters.facilityType = null;
    if (field === 'train') this.backendFilters.train = null;
  }
  this.showFloatingFilter = false;
  this.activeFilter = '';
  this.loadFirstPage();
}

// Return whether any filter (multi-select or date) is currently applied
public hasAnyFilterApplied(): boolean {
  // check rfs date
  if ((this.rfsFilter && (this.rfsFilter.start || this.rfsFilter.end)) || this.backendFilters.startDate || this.backendFilters.endDate) return true;

  // check backend-applied filters
  const bf = this.backendFilters || {};
  if (bf.developmentArea || bf.facilityName || bf.facilityType || bf.train) return true;

  // check local multiFilters selections
  for (const k of Object.keys(this.multiFilters)) {
    if (this.multiFilters[k] && this.multiFilters[k].length) return true;
  }
  return false;
}

// Clear all filters and reload initial data
public clearAllFilters(): void {
  this.multiFilters = {};
  this.filterSearch = {};
  this.rfsFilter = { start: '', end: '' };
  this.backendFilters = {
    developmentArea: null,
    facilityName: null,
    facilityType: null,
    train: null,
    startDate: null,
    endDate: null,
  };
  this.showFloatingFilter = false;
  this.activeFilter = '';
  this.loadFirstPage();
}

// Load filter options - uses API for cascading filters or data for others
private async loadFilterOptions(): Promise<void> {
    const field = this.activeFilter;
    const dynamicFields = ['developmentArea', 'facilityType', 'facilityName', 'train'];
    this.isLoadingFilterOptions = true;
    if (dynamicFields.includes(field)) {
      try {
        const payload = {
          developmentArea: this.multiFilters['developmentArea']?.[0] || null,
          facilityName: this.multiFilters['facilityName']?.[0] || null,
          facilityType: this.multiFilters['facilityType']?.[0] || null,
          train: this.multiFilters['train']?.[0] || null,
        };
        const response = await this.tableService.getFeCapacitiesFilters(payload);
        this.dynamicFilterOptions = {};
        const columnMapping: { [key: string]: string } = {
          'DevelopmentArea': 'developmentArea',
          'FacilityName': 'facilityName',
          'FacilityType': 'facilityType',
          'TrainName': 'train'
        } 
        response.forEach(column => {
          const fieldName = columnMapping[column.columnName];
          if (fieldName) {
            this.dynamicFilterOptions[fieldName] = column.values || [];
          }
        });
      } catch (err) {
      }
    }
    this.isLoadingFilterOptions = false;
  }

// Get filter options for display - handles search and returns filtered list
public getFilterOptions(field: string): string[] {
    const dynamicFields = ['developmentArea', 'facilityType', 'facilityName', 'train'];
    const search = (this.filterSearch[field] || '').toLowerCase();
        if (dynamicFields.includes(field) && this.dynamicFilterOptions[field]) {
      return this.dynamicFilterOptions[field].filter(opt => 
        opt.toLowerCase().includes(search)
      );}
    if (!this.data.length) return [];
    const allOptions = Array.from(
      new Set(this.data.map(row => row[field]).filter(Boolean))
    );
    return allOptions.filter(opt => opt.toLowerCase().includes(search));
}
// Toggle multi-filter for a specific field and value, updating the multiFilters object
public toggleMultiFilter(field: string, value: string, event: any): void {
    if (!this.multiFilters[field]) this.multiFilters[field] = [];
    const isChecked = event.target.checked;
    if (isChecked) {
      if (!this.multiFilters[field].includes(value))
        this.multiFilters[field].push(value);
    } else {
      this.multiFilters[field] = this.multiFilters[field].filter(
        (v) => v !== value
      );
    }
}
// Track by function for ngFor to optimize rendering
public trackByRowId(index: number, row: any): string | number {
  if (!row) return index;
  if (row._rowId) return row._rowId;
  const dev = row.developmentArea || '';
  const type = row.facilityType || '';
  const name = row.facilityName || '';
  const train = row.train || '';
  return `${dev}||${type}||${name}||${train}`;
}
// Check if a value is selected in the multi-filter for a specific field
public isChecked(field: string, value: string): boolean {
    return this.multiFilters[field]?.includes(value);
}
// Apply the selected filter for a specific field, updating filter options based on selections
// public async applyFilter(field: string): Promise<void> {
//     const dynamicFields = ['developmentArea', 'facilityType', 'facilityName', 'train'];
//     if (dynamicFields.includes(field)) {
//       await this.loadFilterOptions();
//     } else {
//       this.showFloatingFilter = false;
//       this.activeFilter = '';
//     }
// }
// Load IPSOMAX dropdown options, ensuring they are loaded only once
// public async loadIpsomaxDropdown(row: any): Promise<void> {
//     if (this.ipsomaxLoaded) return; 
//     try {
//       const result = await this.tableService.getIpsomaxDetails(null, null);
//       const uniqueIpsomax = [...new Set(result.map((item) => item.ipsomaxName).filter(Boolean))];
//       this.lookupData['ipsomax'] = uniqueIpsomax;
//       this.ipsomaxLoaded = true;
//     } catch (err) {
//       this.toastr.error('Failed to load IPSOMAX details.');
//     }
// }
// Handle keydown events for navigating between input fields using arrow keys
public handleKeyDown(event: KeyboardEvent, rowIndex: number, field: string) {
  if (event.key === 'ArrowDown') {
    event.preventDefault();
    const nextInput = document.querySelector<HTMLInputElement>(`[data-cell="${field}-${rowIndex + 1}"]`);nextInput?.focus();
  }
  if (event.key === 'ArrowUp') {
    event.preventDefault();
    const prevInput = document.querySelector<HTMLInputElement>(`[data-cell="${field}-${rowIndex - 1}"]`);prevInput?.focus();
  }
}
// Clear the filter for a specific field, resetting the multiFilters and filterSearch
// public clearFilter(field: string): void {
//     if (field === 'rfsd') {
//       this.rfsFilter = { start: '', end: '' };
//     } else {
//       this.multiFilters[field] = [];
//       this.filterSearch[field] = '';
//     }
//     this.showFloatingFilter = false;
//     this.activeFilter = '';
// }
// Filtered data based on multi-filters and date range for RFSD
public get filteredData(): any[] {
  // server-side filtering in place; just preserve new rows on top
  const newRows = this.data.filter((r) => r.isNew);
  const existing = this.data.filter((r) => !r.isNew);
  return [...newRows, ...existing];
}
// Handle row hover to show dropdowns for ipsomax dropdown for a row
// public toggleIpsomaxDropdown(row: any): void {
//   this.data.forEach((r: any) => (r.showIpsomaxDropdown = false));
//   row.showIpsomaxDropdown = !row.showIpsomaxDropdown;
//   if (row.showIpsomaxDropdown) {
//     row.ipsomaxSearch = '';
//     row.filteredIpsomax = [...(this.lookupData['ipsomax'] || [])];
//   }
//  }
 // Select an ipsomax option from the dropdown  for deselection of ipsoamx options
// public selectIpsomaxOption(row: any, option: string): void {
//   if (row.ipsomax === option) {
//     row.ipsomax = '';
//     row.calculatedOilCapacity = 0;
//     row.calculatedWaterCapacity = 0;
//     row.calculatedGasCapacity = 0;
//   } else {
//     row.ipsomax = option;
//     this.tryPopulateCalculatedFields(row);
//   }
//   row._rowEdited = true;
//   row.showIpsomaxDropdown = false;
// }

// Filter ipsomax options based on user input in the dropdown search
// public filterIpsomaxOptions(row: any): void {
//   const query = (row.ipsomaxSearch || '').toLowerCase();
//   row.filteredIpsomax = this.lookupData['ipsomax'].filter((opt) =>
//     opt.toLowerCase().includes(query)
//   );
// }

@HostListener('document:click', ['$event'])
public onOutsideClick(event: MouseEvent): void {
  const target = event.target as HTMLElement;

  // Close floating filter dropdown if clicked outside
  if (
    !target.closest('.floating-filter-dropdown') &&
    !target.closest('.filter-icon')
  ) {
    this.showFloatingFilter = false;
    this.activeFilter = '';
  }

  // Close IPSOMAX dropdown if clicked outside
  // const clickedInsideIpsomax =
  //   target.closest('.custom-dropdown') || target.closest('.dropdown-panel');

  // // if (!clickedInsideIpsomax) {
  // //   this.data.forEach((row) => {
  // //     if (row.showIpsomaxDropdown) {
  // //       row.showIpsomaxDropdown = false;
  // //     }
  //   });
  // }
 }
}